$ = jQuery;
$(document).ready(main);
$(document).on('shopify:section:load', main);
function main() {
    //====Burger, Mobile Menu====
    $('.menu-burger').on('click', function () {
        $(this).toggleClass('open');
        $('.mobile-main-menu').toggleClass('open');
    });

    var subMenuIcon =
        '<svg class="arrow" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>';
    $(subMenuIcon).insertAfter(
        $('.mobile-main-menu .menu-item-has-children > a')
    );
    $('.mobile-main-menu .menu-item-has-children .arrow').on(
        'click',
        function () {
            $(this).next().slideToggle();
            $(this).toggleClass('active');
            return false;
        }
    );
    //====End Burger, Mobile Menu====
    // ==== Taber ====
    var taber = $('.taber');
    if (taber.length) {
        var hash = window.location.hash;
        var nawItem = taber.find('.nav-item');
        nawItem.on('click', function () {
            nawItem.removeClass('active');
            var id = $(this).data('nav-item');
            $(this).addClass('active');
            taber.find('.info').hide();
            $('[data-tab-info="' + id + '"').fadeIn(500);
        });
        if (hash !== '') {
            var itemId = hash.replace(/^#/, '');
            console.log(itemId);
            taber.find('.nav-item[data-nav-item="' + itemId + '"]').click();
            $('html,body')
                .stop()
                .animate(
                    {
                        scrollTop: $('.posts-taber-block').offset().top,
                    },
                    1500
                );
        } else {
            nawItem.first().click();
        }
    }
    // ==== End Taber ====

    // ==== Customer Slider ====
    var customerSliderBlock = $('.customer-slider-block');
    if (customerSliderBlock.length) {
        var customerSliderBlockSwiper = new Swiper(
            customerSliderBlock.find('.swiper').get(0),
            {
                slidesPerView: 1,
                speed: 1000,
                loop: true,
                spaceBetween: 30,
                pagination: {
                    el: customerSliderBlock.find('.swiper-pagination').get(0),
                    clickable: true,
                },
                navigation: {
                    nextEl: customerSliderBlock
                        .find('.swiper-button-next')
                        .get(0),
                    prevEl: customerSliderBlock
                        .find('.swiper-button-prev')
                        .get(0),
                },
            }
        );
    }
    // ==== End Customer Slider ====
    // ==== FAQ ====
    var faq = $('.faq');
    if (faq.length) {
        var faqItem = faq.find('.item-title');
        faqItem.on('click', function () {
            $(this).toggleClass('active');
            $(this).next().slideToggle(400);
        });
    }
    // ==== End FAQ ====
    // ==== Animation ====
    AOS.init({ duration: 1000 });
    // ==== End Animation ====
}
